module.exports = __webpack_public_path__ + "img/ic_wendang.5c11f596.svg";